import { BaseResponse } from 'domain/payload/response/BaseResponseDto';
import axiosInstance from '../config/AxiosConfig';
import { CoverageAnalysisResp } from 'pages/coverageAnalysis/types';

const CoverageAnalysisService = () => {
  const getCoverageAnalysis = async (token: string): Promise<BaseResponse<CoverageAnalysisResp>> => {
    try {
      const response = await axiosInstance.get('/v1/legacy/cms/coverage-analysis', {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || error.message;
    }
  };

  return { getCoverageAnalysis };
};

export default CoverageAnalysisService;
